import React from "react";
import PropTypes from "prop-types";
import {Dropdown} from "react-bootstrap";
import {CustomMenuStyled, DropDownButton} from "./sharedDDL";

const SimpleDDL = ({
  id,
  list,
  textSelector,
  valueSelector,
  onChange,
  disabled,
  selectedKey,
  getKeyFromListItem = valueSelector,
  isValueSelectorUniqueForId = true
}) => {
  if (!list) {
    list = [];
  }
  let value = list.find((x, idx) => getKeyFromListItem(x, idx) === selectedKey);

  return (
    <Dropdown>
      <Dropdown.Toggle
        id={id}
        as={DropDownButton}
        disabled={disabled}
        className="w-100"
      >
        <span>{value == null ? "-Select-" : textSelector(value)}</span>
        <i className="fa fa-chevron-down" />
      </Dropdown.Toggle>
      <Dropdown.Menu as={CustomMenuStyled} cusHeight={""}>
        <Dropdown.Item
          id={`${id}-option-select`}
          style={{}}
          onClick={() => onChange(null)}
          active={value == null}
        >
          {"-Select-"}
        </Dropdown.Item>
        {list.map((item, idx) => {
          const rawOptionKey = getKeyFromListItem ? getKeyFromListItem(item, idx) : idx;
          const optionKey =
            isValueSelectorUniqueForId &&
            rawOptionKey != null &&
            typeof rawOptionKey !== "object"
              ? rawOptionKey
              : idx;

          return (
            <Dropdown.Item
              key={`${id}-option-${optionKey}`}
              id={`${id}-option-${optionKey}`}
              style={{}}
              onClick={() => onChange(valueSelector(item, idx))}
              active={value == null ? false : getKeyFromListItem(value, idx) === getKeyFromListItem(item, idx)}
            >
              {textSelector(item)}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

SimpleDDL.propTypes = {
  id: PropTypes.string.isRequired,
  list: PropTypes.array,
  textSelector: PropTypes.func.isRequired,
  valueSelector: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  selectedKey: PropTypes.any,
  getKeyFromListItem: PropTypes.func,
  isValueSelectorUniqueForId: PropTypes.bool,
};

export { SimpleDDL };
